module.exports = __webpack_public_path__ + "static/educate-magis-en-80e3fa60f762c513c80511d7fe761ac9.svg";